import React from 'react';
import './Booking-input.css';

const Bookinginput = ({ title, type, placeholder, icon, value, onChange, error }) => {
  return (
    <div className="Booking-input-contanir">
      <h4 className="Booking-input-text1">{title}</h4>
      <div className="Booking-input-wrapper">
        <span className="Booking-input-icon-wrap">{icon}</span>
        <input
          className={`Booking-input-div ${error ? 'input-error' : ''}`}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </div>
      {error && <span className="input-error-text">{error}</span>}
    </div>
  );
};

export default Bookinginput;